import React from 'react';

export const EyeIcon = () => (
    <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.25 10C1.25 10 3.75 4.375 10 4.375C16.25 4.375 18.75 10 18.75 10C18.75 10 16.25 15.625 10 15.625C3.75 15.625 1.25 10 1.25 10Z" stroke="#1B1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="#1B1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);